import React, { useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import NotFound from '../../components/NotFound';
import { GET_USER_RENT_GUARANTEE_DETAILS } from '../../graphql/queries';
import useCustomQuery from '../../network/useCustomQuery';
import OneTimePayment from './OneTimePayment';
import PaymentTypeWrapper from './_partials/PaymentTypeWrapper';

const PaymentType = () => {
  const { id } = useParams();

  const [getUserGuaranteeDetails, getUserGuaranteeDetailsLoading, getUserGuaranteeDetailsData] =
    useCustomQuery({
      query: GET_USER_RENT_GUARANTEE_DETAILS,
      onError: () => {},
      onData: () => {}
    });

  useEffect(() => {
    if (id) {
      getUserGuaranteeDetails({
        variables: {
          getUserRentGuaranteeSingleId: id
        }
      });
    }
  }, [id]);

  const rootData =
    getUserGuaranteeDetailsData?.getUserRentGuaranteeSingle?.data?.meta?.guaranteePreviewData?.data;

  const address =
    getUserGuaranteeDetailsData?.getUserRentGuaranteeSingle?.data?.property?.propertyAddress;

  return (
    <div>
      <PaymentTypeWrapper
        id={id}
        payload={rootData?.oneTimePayment}
        address={address}
        loading={getUserGuaranteeDetailsLoading}>
        <Routes>
          <Route
            path="/one-time-payment"
            element={
              <OneTimePayment
                payload={rootData?.oneTimePayment}
                address={address}
                type="one-time"
                loading={getUserGuaranteeDetailsLoading}
                id={id}
              />
            }
          />
          <Route
            path="/installment-payment"
            element={
              <OneTimePayment
                payload={rootData?.installment}
                address={address}
                type="installment"
                loading={getUserGuaranteeDetailsLoading}
                id={id}
              />
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PaymentTypeWrapper>
    </div>
  );
};

export default PaymentType;
